import React, { useContext, useEffect } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { Avatar } from "react-native-elements";
import { useNavigation } from "@react-navigation/native";

import {
  Content,
  CardLatestDeliveries,
  ContainerDescription,
  ContentAvatar,
  DataUser,
  IconContainer,
  IconContainerAction,
  IconFE,
  IconIo,
  StatusDelivery,
  TextDeliveries,
  TitleDataUser,
  TitleDelivery,
} from "./styles";
import { Header, Button, Container } from "../../../components";
import { themes } from "../../../design/colors";
import Profile from "../../Profile";
import ClientContext from "../../../context/client";
import CardClients from "../../../components/CardClients";

function ClientsAdmin() {
  const navigation = useNavigation();
  const { clients } = useContext(ClientContext);

  function handleAddClient() {
    navigation.navigate("AddClientAdmin", { edit: false });
  }

  function handleEditAddClient(id: number) {
    navigation.navigate("AddClientAdmin", { edit: true, id });
  }

  return (
    <Container>
      <Header name="Bruno Morais" />
      <Content>
        <TextDeliveries>Clientes cadastrados</TextDeliveries>
        <Button title="Adicionar novo cliente" icon="plus" onPress={handleAddClient} />
        {clients.map((item: any, index: number) => (
          <CardClients
            key={index}
            first={index === 0 && true}
            title={item.name}
            status={!!item.active ? 'Ativo' : 'Inativo'}
            onPress={() => handleEditAddClient(item.id)}
          /> 
        ))}
      </Content>
    </Container>
  );
}

export default ClientsAdmin;
